import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';
import { pick } from 'Helpers/Affordances';
import GuidedHouseholdReviewLayout from './GuidedHouseholdReviewLayout';
import RoadmapDeliverableLayout from './RoadmapDeliverableLayout';

const addOverrides = (baseOverrides) => baseOverrides
  .done();

const roadmapDeliverableMetaOverrideSet = addOverrides(buildFacetDesignOverride());
const guidedHouseholdReviewMetaOverrideSet = addOverrides(buildBaseOverrides());

const RoadmapGoalsNext12MonthsStepTemplate = ({ resource }) => {
  const layout = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: GuidedHouseholdReviewLayout,
  }, RoadmapDeliverableLayout);
  const metaOverrideSet = pick(resource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: guidedHouseholdReviewMetaOverrideSet,
  }, roadmapDeliverableMetaOverrideSet);
  return (
    <MetaResourceRenderer
      layout={layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

RoadmapGoalsNext12MonthsStepTemplate.defaultProps = {
};

RoadmapGoalsNext12MonthsStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default RoadmapGoalsNext12MonthsStepTemplate;
